import React, { Suspense } from "react";

/**
 * Soft, non-flickering Suspense fallback for BeeNest.
 * Renders the calm honeycomb backdrop while a lazy chunk loads.
 * Intentionally has no spinner — just a quiet cream space.
 */
const Fallback = () => (
  <div
    className="min-h-screen bn-honeycomb"
    role="status"
    aria-live="polite"
    aria-label="Settling in softly"
    data-testid="soft-suspense-fallback"
  />
);

export const SoftSuspense = ({ children }) => (
  <Suspense fallback={<Fallback />}>{children}</Suspense>
);

export default SoftSuspense;
